<div class="dialog__wrapper">
  <div class="dialog__header" mat-dialog-title>
    <h4 class="dialog__title">{{ data.title }}</h4>
    <button mat-dialog-close mat-icon-button>
      <mat-icon mat-button class="icon" fontIcon="close"></mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <div>
      <table mat-table [dataSource]="dataSource$ | async">
        <ng-container matColumnDef="organisationName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Organisation Name</th>
          <td mat-cell *matCellDef="let element">{{ element.organisationName }}</td>
        </ng-container>

        <ng-container matColumnDef="from">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>From</th>
          <td mat-cell *matCellDef="let element">{{ element.statusFromName }}</td>
        </ng-container>

        <ng-container matColumnDef="to">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>To</th>
          <td mat-cell *matCellDef="let element">{{ element.statusToName }}</td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Action name</th>
          <td mat-cell *matCellDef="let element">{{ element.actionName }}</td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
          <td mat-cell *matCellDef="let element">{{ element.date | date: DateConstants.dateWithTime }}</td>
        </ng-container>

        <ng-container matColumnDef="author">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Author</th>
          <td mat-cell *matCellDef="let element">{{ element.byUser }}</td>
        </ng-container>

        <ng-container matColumnDef="reason">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Reason</th>
          <td mat-cell *matCellDef="let element">{{ element.reason }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: columns"></tr>

        <tr *matNoDataRow>
          <td colspan="5">No data matching the filter.</td>
        </tr>
      </table>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button (click)="handleClose()">Close</button>
  </mat-dialog-actions>
</div>
